import { redirect } from 'react-router-dom';
import { useApplicationStore } from '@data';

export default async function completeProfileLoader(): Promise<Response | null> {
  const { verificationToken } = useApplicationStore.getState();

  if (!verificationToken) {
    return redirect('/services');
  }

  return null;
}
